import { Link } from "react-router-dom"

function Error401() {

  return (
    <div className="pageContainer">
        <div className="error401 column">
            <div className="error401Title">
                Error 401
            </div>
            <div className="error401Body">
                credenciales incorrectas<br />
                en caso de persistencia contactar con un administrador
            </div>
            <div className="error401Button">
                <Link to="/login">volver al login</Link>
            </div>
        </div>
    </div>
  )
}

export default Error401